import { Box, Typography } from "@mui/material";
import moment from "moment";
import { useAppContext } from "../../../2_ksbHub/context/appContext";
import { useBszPlannerContext } from "../context/bszPlannerContext";

moment.locale("de");

export const BSZPlannerTitle = () => {
  const { isMobile, currentUser } = useAppContext();
  const { selectedClass } = useBszPlannerContext();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "row" : "column",
        alignItems: isMobile ? "flex-end" : "flex-start",
        justifyContent: isMobile ? "flex-start" : "unset",
        gap: isMobile ? 0 : 0,
        whiteSpace: "nowrap",
      }}
    >
      {/* ✅ Desktop only */}
      {!isMobile && (
        <Typography variant="h6" color="primary">
          BSZ Projekte
        </Typography>
      )}

      {/* ✅ Subtitle */}
      <Typography
        color="primary"
        variant={isMobile ? "h6" : "h4"}
        fontWeight="bold"
      >
        {/* {moment(referenceDate).format(isMobile ? "dd, DD.MM." : "dd, DD. MMMM")} */}
        {isMobile
          ? `Planner · ${selectedClass ? selectedClass?.name : currentUser.abbreviation}`
          : selectedClass
            ? selectedClass?.name
            : currentUser.abbreviation}
      </Typography>
    </Box>
  );
};
